export const extensionRoutes = [  {
    path: 'extensions/ads',
    loadChildren: () => import('./extensions/f842d93dd5d072a049c4d164a22f0bd11f932b4faa4abd6add6ff869b764a0c6/route'),
  }];
